import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Text, View, SafeAreaView, ScrollView } from 'react-native';
import Theme from '../theme';
import { FormKeyboardSpacer } from '../ui';
import { Button, ButtonTypes, Heading } from '../components';
import { TextInput, FormError } from '../ui';
import GuardianFields from './GuardianFields';
import { LogoutHelper, UserDataConsumer } from '../utils';
import { styles } from './SignupFormsStyles';

class CaptureMissingGuardianDetails extends Component {
  state = {
    isLoading: false,
    error: null,
    initialValues: {},
  };

  componentDidMount = () => {
    const { user: { userProfile } } = this.props;
    const guardianInfo = userProfile.guardianInfo ? userProfile.guardianInfo : {};
    const initialValues = {
      name: guardianInfo.name,
      lastname: guardianInfo.lastname,
      contactNumber: guardianInfo.contactNumber,
      email: guardianInfo.email,
      address: guardianInfo.address,
    };
    this.setState({ initialValues });
  }

  onSubmit = async (values) => {
    try {
      const { user: { userProfile, userProfileService }, navigation } = this.props;
      this.setState({ isLoading: true, error: null });
      userProfile.guardianInfo = { ...userProfile.guardianInfo, ...values };
      await userProfileService.updateUserProfile(userProfile);
      navigation.navigate('HomeLoading');
    } catch (error) {
      this.setState({ error });
    } finally {
      this.setState({ isLoading: false });
    }
  }

  logout = async () => {
    await LogoutHelper();
  }

  render() {
    const { t } = this.props;
    const { isLoading, initialValues, error } = this.state;

    return (
      <SafeAreaView style={{ flex: 1, backgroundColor: Theme.GREY_DARK }}>
        <View style={[styles.container, { backgroundColor: Theme.GREY_DARK }]}>
          <FormKeyboardSpacer>
            <ScrollView
              keyboardShouldPersistTaps="handled"
              showsVerticalScrollIndicator={false}
              contentContainerStyle={styles.scrollViewContainer}>
              <View style={styles.headerContainer}>
                <Heading
                  style={[styles.createAccountHeader, { color: Theme.WHITE }]}
                  title={'Your legal guardian’s details...'}
                />
              </View>

              <GuardianFields
                initialValues={initialValues}
                textInputComponent={TextInput}
                navigation={this.props.navigation}
                render={({ message, handleSubmit, isUnderage }) => {
                  return (
                    <>
                      <View style={styles.footer}>
                        {message &&
                          <Text style={[styles.message, { color: Theme.WHITE }]}>{message}</Text>
                        }
                        <FormError color={Theme.WHITE} error={error} />
                        <Button
                          isLoading={isLoading}
                          disabled={isUnderage}
                          fontColor={Theme.WHITE}
                          containerStyle={{ marginTop: 3 }}
                          onPress={handleSubmit(this.onSubmit)}
                          title={t('continue')}
                        />
                        <Button
                          fontColor={Theme.PRIMARY}
                          buttonType={ButtonTypes.OUTLINE}
                          title={'Logout'}
                          onPress={this.logout}
                          containerStyle={{ marginTop: 5 }}
                        />
                      </View>
                    </>
                  )
                }}
              />
            </ScrollView>
          </FormKeyboardSpacer>
        </View>
      </SafeAreaView>
    );
  }
}

CaptureMissingGuardianDetails = translate(['auth', 'formFields'], { wait: true })(CaptureMissingGuardianDetails);
CaptureMissingGuardianDetails = UserDataConsumer(CaptureMissingGuardianDetails);
export default CaptureMissingGuardianDetails;
